module.exports = __webpack_public_path__ + "img/H-B-5-load-standup-shadow.dd82fad4.png";